import apiRequest from './index'

export default {
  path: '/v1/inspection_settlement_gmoapicall',
  // post (inspectionSettlement) {
  //   return apiRequest.post(this.path, { ...inspectionSettlement })
  // }
  async post (inspectionSettlement) {
    console.log('gmoに送信しているPOST値')
    console.log(inspectionSettlement)
    await window.callNativeHTTPX()
    return apiRequest.post(this.path, { ...inspectionSettlement }, {
      headers: {
        'HTTP-X-DAPP-REQUESTTIME': window.DAPP_REQUESTTIME,
        'HTTP-X-DAPP-USERID': window.DAPP_USERID,
        'HTTP-X-DAPP-AUTHCD': window.DAPP_AUTHCD
      }
    })
  }
}
